import axios from "axios";
import { createApp } from "vue";
// import logging from './logging';
import ErrorHandler from "@/common/services/ErrorHandler/ErrorHandler";
import analytics from "../../gallery/analytics.js";
import splitTest from "../../gallery/splitTest.js";
import frisbuyGallery from "./gallery/gallery.vue";
// TODO: change next line to  `import Vue3TouchEvents from "vue3-touch-events";` and check it. `touchevents.js` can be deleted
import Vue2TouchEvents from "../../gallery/touchevents";
import postitem from "./postitem/postitem.vue";

// TODO: check this import for needed
import "intersection-observer";
// TODO: move styles import to component
import "../../gallery/popup/popup.scss";
import { sendToGa4Dictionary } from "../../gallery/helpers.js";
import { initDevMode } from "@/dev/dev.init.js";

import { sendFrisbuyAnalyticsEvent } from "@/common/services/FrisbuyAnalytics/FrisbuyAnalytics";
import widgetTypes from "@/common/consts/widgetTypes.js";

const widgetStart = (performance && performance.now()) || null;

new ErrorHandler().init();

// window.frisbuy.notaccesed = [2];
// window.frisbuy.udi = { "3a8ce262-0bb6-4f25-9b79-27e884995d0c": 2 };
// window.frisbuy.domains = [
//   "https://widget01.frisbuy.ru",
//   "https://widget02.frisbuy.ru",
//   "https://widget03.frisbuy.ru",
// ];

window.frisbuy = window.frisbuy || {};
window.frisbuy.widgets = window.frisbuy.widgets || {};

window.frisbuy.widgets.gallery = {
  init(embedId) {
    const {
      settings,
      mobileSettings,
      postList,
      extraData,
      isDev,
      lastPage,
      postCount,
    } = window.frisbuy[embedId];
    const { splitTest: settingsSplitTest } = settings;

    let initWidget = function () {};

    settings.widgetStart = widgetStart;

    analytics(settings);

    if (settingsSplitTest.name) {
      window.frisbuy[embedId].blockInitWidget = true;
      if (
        splitTest.getTestGroup(
          settingsSplitTest.name,
          settingsSplitTest.groups,
          settingsSplitTest.firstEntryAttrs,
          settings.srcDomain,
          function (groupName, groupAttributes) {
            let dimensionId = settingsSplitTest.dimensionId;
            dimensionId = dimensionId || 22;

            if (
              settingsSplitTest.settings &&
              groupName in settingsSplitTest.settings
            ) {
              settings.popup = {
                ...settings.popup,
                ...settingsSplitTest.settings[groupName].popup,
              };
              settings.gallery = {
                ...settings.gallery,
                ...settingsSplitTest.settings[groupName].gallery,
              };
            }

            const hideGallery =
              groupName === "hide" ||
              (settings.gallery.hide && settings.gallery.hide == 1);

            if (groupAttributes && groupAttributes.excludeFromTest) {
              if (!hideGallery) {
                window.frisbuy[embedId].blockInitWidget = false;
                initWidget();
              }
            } else if (dimensionId) {
              splitTest.setGroupNameInGa(
                settingsSplitTest.name,
                groupName,
                {
                  frisbuyTrackerId: settings.analytics.ga4.frisbuyTrackerId,
                  clientTrackerId: settings.analytics.ga4.clientTrackerId,
                  embed_id: settings.embedId,
                  postList: postList,
                  sku_id: settings.skuId,
                  skug_id: settings.groupId,
                  category_id: settings.categoryId || null,
                },
                dimensionId,
                settings.customerCode,
                function () {
                  if (!hideGallery) {
                    window.frisbuy[embedId].blockInitWidget = false;
                    initWidget();
                  }
                }
              );

              // YM
              splitTest.sendYMSplitTestEvent(
                settings.analytics.ym.clientCounterId,
                settingsSplitTest.name,
                groupName,
                {
                  embedId: settings.embedId,
                  skuId: settings.skuId,
                  skuGroupId: settings.groupId,
                  categoryId: settings.categoryId || null,
                },
                () => {}
              );
            } else {
              splitTest.setGroupNameInGa(
                settingsSplitTest.name,
                groupName,
                {
                  frisbuyTrackerId: settings.analytics.ga4.frisbuyTrackerId,
                  clientTrackerId: settings.analytics.ga4.clientTrackerId,
                  embed_id: settings.embedId,
                  postList: postList,
                  sku_id: settings.skuId,
                  skug_id: settings.groupId,
                  category_id: settings.categoryId || null,
                },
                null,
                settings.customerCode
              );

              // YM
              splitTest.sendYMSplitTestEvent(
                settings.analytics.ym.clientCounterId,
                settingsSplitTest.name,
                groupName,
                {
                  embedId: settings.embedId,
                  skuId: settings.skuId,
                  skuGroupId: settings.groupId,
                  categoryId: settings.categoryId || null,
                },
                () => {}
              );

              if (!hideGallery) {
                window.frisbuy[embedId].blockInitWidget = false;
                initWidget();
              }
            }
          }
        )
      );
    }

    let widgetContainer;
    let containerDetectInterval;
    let isInitialized = false;

    initWidget = function () {
      if (window.frisbuy[embedId].blockInitWidget || isInitialized) {
        return;
      }

      // @todo a.matuhnov: review code block
      const specifiedElement = document.querySelector(
        settings.widgetContainerSelector
      );
      if (!settings.widgetContainerPlacement) {
        widgetContainer = specifiedElement;
      } else {
        const dynamicContainerId =
          "frisbuy-widget-" + Math.random().toString(36).substring(2);
        if (settings.widgetContainerPlacement === "after") {
          specifiedElement.insertAdjacentHTML(
            "afterEnd",
            '<div id="' + dynamicContainerId + '"></div>'
          );
        } else if (settings.widgetContainerPlacement === "before") {
          specifiedElement.insertAdjacentHTML(
            "beforeBegin",
            '<div id="' + dynamicContainerId + '"></div>'
          );
        }

        widgetContainer =
          document.querySelector("#" + dynamicContainerId) || specifiedElement;
      }
      // end review code block

      if (!widgetContainer) return false;

      if (containerDetectInterval) {
        clearInterval(containerDetectInterval);
      }

      if (widgetContainer.hasAttribute("data-v-app")) {
        console.error(
          "Frisbuy widget [gallery] already mounted on page",
          widgetContainer
        );
        return;
      }

      const nodes = document.querySelectorAll(
        "#frisbuy-container-block,#frisbuyAutoShow"
      );

      Array.from(nodes).forEach((node) => (node.style.display = "block"));

      // const popupDiv = window.document.createElement('div');

      // popupDiv.setAttribute('id', 'frisbuy_popup');

      // document.body.insertBefore(popupDiv, document.body.children[0]);

      // settings.popupContainer = popupDiv;

      const propsData = {
        propSettings: settings,
        mobileSettings,
        propPostList: postList,
        extraData,
        lastPage,
        postCount,
      };

      const gallery = createApp(frisbuyGallery, propsData)
        .use(Vue2TouchEvents, {
          disableClick: true,
          tapTolerance: 5,
          swipeTolerance: 50,
        })
        .component("post-item", postitem)
        .mixin(mixin);

      if (!isDev) {
        gallery.config.productionTip = false;
        gallery.config.silent = true;
        gallery.config.devtools = false;
      }

      // TODO: remove this.
      // It doesn't need because in Vue3 reactivity via window or another outer vars doesn't work
      window.frisbuy[embedId].gallery = gallery;

      gallery.mount(widgetContainer);

      isInitialized = true;

      return true;
    };

    // if container is not present
    if (!initWidget()) {
      // re-check in 50 seconds
      setTimeout(function () {
        // if container is still not present - keep trying every 100 ms
        if (!initWidget()) {
          containerDetectInterval = setInterval(initWidget, 100);
          // stop waiting 3 secs after page load
          window.addEventListener("load", function () {
            setTimeout(function () {
              initWidget();

              if (containerDetectInterval) {
                clearInterval(containerDetectInterval);
              }
            }, 3000);
          });
        }
      }, 50);
    }
  },
};

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.withCredentials = true;

const mixin = {
  computed: {
    isRetina() {
      return false;
    },

    trackingSkuId() {
      const { skuId, groupId, categoryId } = this.settings;

      return (
        (skuId && `_sku${skuId}`) ||
        (groupId && `_skug${groupId}`) ||
        (categoryId && `_cat${categoryId}`) ||
        ""
      );
    },

    trackingTagCode() {
      const { tagCode } = this.settings;
      return tagCode ? `_tagCode${tagCode}` : "";
    },

    categoryPrefix() {
      return this.settings.analytics?.categoryPrefix || "";
    },

    actionPrefix() {
      const actionPrefix = this.settings.analytics?.actionPrefix;

      return actionPrefix ? `_${actionPrefix}` : "";
    },

    envDomain() {
      if (process.env.NODE_ENV == "development") return "";

      return (
        process.env.PUBLIC_SCHEME +
        "://" +
        process.env.VIRTUAL_HOST.split(",")[0]
      );
    },
  },

  methods: {
    sendGAEvent(action, label, sendToClient, isNonInteraction) {
      const originalAction = action;
      const data = this;

      const {
        settings,
        categoryPrefix,
        actionPrefix,
        trackingSkuId,
        trackingTagCode,
      } = this;
      const { analytics } = settings;
      const category = `Frisbuy_Gallery_${
        categoryPrefix + settings.customerCode
      }`;
      const labelItemPosition = [
        "fbProduct",
        "igCode",
        "slide",
        "link",
        "linklabel",
        "product",
        "variation",
        "offer",
        "index",
        "swipeType",
        "shareType",
        "queued",
        "load",
        "bundle",
        "domInject",
        "filter",
      ];
      const labelString =
        typeof label === "object"
          ? labelItemPosition.reduce((labelString, currentLabelItem) => {
              if (!Object.hasOwn(label, currentLabelItem)) return labelString;

              return (
                (labelString ? labelString + "_" : labelString) +
                currentLabelItem +
                label[currentLabelItem]
              );
            }, "")
          : label;

      if (!action.includes("ClickMainLink")) {
        action = `${action}_gallery${settings.galleryId}_embedID${
          settings.embedId + actionPrefix + trackingSkuId + trackingTagCode
        }`;
      }

      if (action.includes("FilterElastic")) {
        const { elasticFilter } = settings.analytics;

        let filterValue = 0;

        if (elasticFilter) {
          filterValue = elasticFilter.elasticTitle;
        }

        action = `FilterElastic_gallery${settings.galleryId}_embedID${
          settings.embedId
        }_filter${
          filterValue + actionPrefix + trackingSkuId + trackingTagCode
        }`;
      }

      if (
        settings.analytics?.elasticFilter &&
        !action.includes("FilterElastic")
      ) {
        const { gender, color, categoryId } = settings.analytics.elasticFilter;

        action += `_cat${categoryId}_gender${gender}_color${color}`;
      }

      if (settings.analytics?.ga.sendToGa) {
        if (settings.verbose) {
          console.log(
            `%cSend event: %c${category} %c${action} %c${labelString}`,
            "color: red; font-weight: bold",
            "color: blue",
            "color: green",
            "color: darkcyan"
          );
        }

        // GA3
        // if (window.frisbuyGa) {
        //   if (isNonInteraction) {
        //     window.frisbuyGa(
        //       'frisbuyGa.send',
        //       'event',
        //       category,
        //       action,
        //       labelString,
        //       {
        //         nonInteraction: true
        //       }
        //     );
        //   } else {
        //     window.frisbuyGa(
        //       'frisbuyGa.send',
        //       'event',
        //       category,
        //       action,
        //       labelString
        //     );
        //   }
        // }

        // GA4
        if (window.frisbuyGa4) {
          sendToGa4Dictionary(originalAction, data, label, true);
        }
      }

      if (!sendToClient) return;

      if (analytics?.gtm && analytics?.gtm.eventName) {
        const { gtm } = analytics;
        const gtmPayload = Object.assign(gtm.static || {}, {
          event: gtm.eventName,
          [gtm.eventCategory]: "Frisbuy_Gallery",
          [gtm.eventAction]: action,
          [gtm.eventLabel]: labelString,
          [gtm.eventNonInteractive]: isNonInteraction,
        });

        window.frisbuyGTM(gtmPayload);
      }

      if (analytics?.ga.sendToClient) {
        if (settings.verbose) {
          console.log(
            `${window["GoogleAnalyticsObject"]}('send', 'event', 'Frisbuy_Gallery', '${action}', '${labelString}')`
          );
        }

        /* [HACK]
          After Google did update GA3 -> GA4
          our GA3-funcs become send events to GA4
          along with GA4-funcs.

          Need refactor our analytic to remove
          old `frisbuyGa` or new `frisbuyGa4`
        */

        // if (window.frisbuyGa) {
        //   if (isNonInteraction) {
        //     window.frisbuyGa(
        //       `send`,
        //       'event',
        //       'Frisbuy_Gallery',
        //       action,
        //       labelString,
        //       {
        //         nonInteraction: true
        //       }
        //     );
        //   } else {
        //     window.frisbuyGa(
        //       `send`,
        //       'event',
        //       'Frisbuy_Gallery',
        //       action,
        //       labelString
        //     );
        //   }
        // }

        if (window.frisbuyGa4) {
          sendToGa4Dictionary(originalAction, data, label);
        }
      }
    },

    sendYMEvent(action, label) {
      const {
        galleryId: gallery,
        embedId: embedID,
        skuId,
        tagCode,
      } = this.settings;
      const clientCounterId = this.settings.analytics?.ym.clientCounterId;
      const conunterId = `yaCounter${clientCounterId}`;
      const ymParams = typeof label === "object" ? label : {};

      if (!clientCounterId || !window[conunterId]) {
        return;
      }

      Object.assign(ymParams, {
        gallery,
        embedID,
        widgetType: widgetTypes.GALLERY,
      });

      if (skuId) {
        ymParams.sku = skuId;
      }

      if (tagCode) {
        ymParams.tagCode = tagCode;
      }

      if (ymParams.linklabel) {
        ymParams.linklabel = ymParams.linklabel.replace(/[^\w]+/g, "+");
      }

      window[conunterId].reachGoal(`Frisbuy${action}`, ymParams, () => {
        if (!this.settings.verbose) return;

        console.log(conunterId + ".push", `Frisbuy${action}`, ymParams);
      });
    },

    sendAnaliticEvent(
      action,
      label,
      sendToClient = true,
      isNonInteraction = false
    ) {
      this.sendGAEvent(action, label, sendToClient, isNonInteraction);
      this.sendYMEvent(action, label);

      // [START] Frisbuy Analytics
      const frisbuyParams = {
        srcDomain: this.settings.srcDomain,

        embedId: this.settings.embedId,
        galleryId: this.settings.galleryId,
        skuId: this.settings.skuId,
        skuGroupId: this.settings.groupId,
        categoryId: this.settings.categoryId,
        tagCode: this.settings.tagCode,
        frUId: this.settings.frisbuyUID,
      };

      // TODO: check `label` on correct data
      if (typeof label === "object") {
        Object.assign(frisbuyParams, label);
      }

      sendFrisbuyAnalyticsEvent(action, frisbuyParams);
      // [END] Frisbuy Analytics
    },
    getOffset(element) {
      const { left, top, width, height } = element.getBoundingClientRect();
      let parent = { left: 0, top: 0 };

      if (element.parentElement) {
        parent = this.getOffset(element.parentElement);
      }

      return { left: left + parent.left, top: top + parent.top, width, height };
    },

    // @todo: invalid method name
    isElementInView: function (element, isFull = false) {
      if (!element) return;

      const { top, bottom, height } = element.getBoundingClientRect();
      const { innerHeight: windowHeight } = window;

      if (isFull) {
        return (
          (height > windowHeight && bottom > 0 && bottom < windowHeight) ||
          (top > 0 && bottom < windowHeight)
        );
      } else {
        return top < windowHeight;
      }
    },

    isFunction: function (functionToCheck) {
      return (
        functionToCheck &&
        {}.toString.call(functionToCheck) === "[object Function]"
      );
    },

    hideBuyButton(product) {
      const { skuProductPageGroupId, skuId } = this.settings;

      if (!this.settings.popup?.hideSkuSelfLink) return;

      if (skuProductPageGroupId && product.sku.productPageGroupId) {
        return skuProductPageGroupId == product.sku.productPageGroupId;
      } else if (skuId) {
        return skuId == product.sku.offerId;
      }

      return false;
    },

    imageURL(source, isStandartLow, getHighResolution) {
      const { isRetina } = this;

      if (!source) return;

      if (isStandartLow) {
        return isRetina || getHighResolution
          ? {
              imageLowRes: source.imageUrl,
              imageHighRes: source.imageHighResolutionUrl,
            }
          : { imageLowRes: source.thumbnailUrl, imageHighRes: source.imageUrl };
      } else {
        return isRetina || getHighResolution
          ? { imageLowRes: source.thumbnailUrl, imageHighRes: source.imageUrl }
          : {
              imageLowRes: source.thumbnailUrl,
              imageHighRes: source.thumbnailUrl,
            };
      }
    },

    mergeSettings(data) {
      const setProperty = (fromObject, toObject) => {
        Object.keys(fromObject).forEach((property) => {
          const propertyValue = fromObject[property];

          if (
            typeof propertyValue === "object" &&
            propertyValue !== null &&
            !Array.isArray(propertyValue)
          ) {
            setProperty(propertyValue, toObject[property]);
            return;
          }

          if (propertyValue === toObject[property]) return;

          toObject[property] = propertyValue;
        });
      };

      setProperty(data, this.settings);
    },

    merge() {
      var dst = {},
        src,
        p,
        args = [].splice.call(arguments, 0);
      while (args.length > 0) {
        src = args.splice(0, 1)[0];
        if (toString.call(src) == "[object Object]") {
          for (p in src) {
            if (Object.hasOwn(src, p)) {
              if (toString.call(src[p]) == "[object Object]") {
                dst[p] = this.merge(dst[p] || {}, src[p]);
              } else {
                dst[p] = src[p];
              }
            }
          }
        }
      }

      return dst;
    },

    getCookie: splitTest.getCookie,

    setCookie: splitTest.setCookie,
  },
};

window.frisbuy.updateGalleryData = function (query = {}, embedId) {
  const { gallery } = window.frisbuy[embedId];
  const sourceUrl = new URL(window.frisbuy[embedId].settings.sourceUrl);
  const urlQuery = sourceUrl.search
    .replace("?", "")
    .split("&")
    .reduce((queryObject, currentParam) => {
      const [key, value] = currentParam.split("=");

      queryObject[key] = decodeURIComponent(value);
      return queryObject;
    }, {});

  Object.assign(urlQuery, query);

  if (!gallery) return;

  window.frisbuy[embedId].postList.splice(
    0,
    window.frisbuy[embedId].postList.length
  );

  urlQuery["with_settings"] = 1;

  sourceUrl.search =
    "?" +
    Object.keys(urlQuery)
      .reduce((paramsArray, currentParam) => {
        paramsArray.push(
          `${currentParam}=${encodeURIComponent(urlQuery[currentParam])}`
        );
        return paramsArray;
      }, [])
      .join("&");

  gallery.getPosts(sourceUrl.href, ({ settings }) => {
    gallery.settings.groupId = settings.groupId;
    gallery.settings.skuId = settings.skuId;
    gallery.settings.tagCode = settings.tagCode;
    gallery.settings.analytics.actionPrefix = settings.analytics.actionPrefix;
    gallery.settings.analytics.categoryPrefix =
      settings.analytics.categoryPrefix;

    // gallery.sendAnaliticEvent('Load', window.location.href, true, true);
    // gallery.sendAnaliticEvent('Eyesight', window.location.href, true, true);
  });
};

if (process.env.NODE_ENV === "development") {
  (async () => await initDevMode())();
}
